// extracted by mini-css-extract-plugin
export var list = "NumbersList-module--list--735cY";
export var item = "NumbersList-module--item--2DSUu";